import { Link } from 'react-router-dom'

export const Projects = () => {
    return (
        <>
            <section className="h-[100svh] flex flex-col gap-[2rem] items-center justify-center font-jakarta bg-[#002921]">
                <h3 className="text-white text-[2rem] md:text-[4rem] tracking-tight">Page Coming Soon</h3>
                <Link
                    to={'/'}
                    id="button-animation"
                    className="flex items-center group gap-[0.6rem] w-max rounded-full border border-gray-400 text-[1rem] text-[#828997] py-[0.8rem] px-[1.4rem]"
                >
                    <svg
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-[1.1rem] w-[1.1rem] mt-[2px] stroke-[#828997] rotate-[225deg] group-hover:stroke-[#002921]"
                    >
                        <path
                            d="M10.3291 5.68945H20.6694C20.727 5.68945 20.7738 5.73622 20.7738 5.7939V16.1342"
                            stroke-width="2.08894"
                            stroke-miterlimit="10"
                        ></path>
                        <path
                            d="M20.7744 5.68945L7.19629 19.2676"
                            stroke-width="2.08894"
                            stroke-miterlimit="10"
                        ></path>
                    </svg>
                    <span className="font-medium">Back to Home</span>
                </Link>
            </section>
        </>
    )
}